var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 12.6005C8.47489 12.6005 7.94989 12.398 7.55239 12.0005L2.66239 7.11047C2.44489 6.89297 2.44489 6.53297 2.66239 6.31547C2.87989 6.09797 3.23989 6.09797 3.45739 6.31547L8.34739 11.2055C8.70739 11.5655 9.29239 11.5655 9.65239 11.2055L14.5424 6.31547C14.7599 6.09797 15.1199 6.09797 15.3374 6.31547C15.5549 6.53297 15.5549 6.89297 15.3374 7.11047L10.4474 12.0005C10.0499 12.398 9.52489 12.6005 8.99989 12.6005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.d3bcade97e86799c803071100481bdc5.svg";
export { ForwardRef as ReactComponent };